import { useSelector } from 'react-redux';
import PaymentMethodModel from 'models/common/PaymentMethod';
import { PaymentPreference, PaymentPriority } from 'models/enums';
import { selectFullUser } from 'store/redux/user/selectors';

export function usePaygPaymentMethod(): PaymentMethodModel | null {
  const fullUser = useSelector(selectFullUser);

  return (
    fullUser?.getPaymentMethodFor(
      PaymentPreference.Maintenance,
      PaymentPriority.Primary,
    ) ??
    [...(fullUser?.getPaymentMethods(null, true) ?? [])].sort(
      (a: PaymentMethodModel, b: PaymentMethodModel) =>
        a.accountId.localeCompare(b.accountId),
    )[0] ??
    null
  );
}
